import { httpsCallable } from 'firebase/functions'

import { functions } from '../firebase'
import { apiSlice } from './apiSlice'

// Helper type for error responses
interface FirebaseError {
  code?: string
  message: string
}

export const stripeApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({

    // Trigger stripe membership payment
    triggerMembershipPayment: builder.mutation({
      async queryFn() {
        try {
          const callable = httpsCallable(functions, 'createPaymentSession')
          const result = await callable()

          return { data: result.data }
        } catch (error) {
          const err = error as FirebaseError
          return {
            error: {
              status: err.code || 500,
              data: {
                message: err.message
              }
            },
          }
        }
      }
    }),

    // Check checkout status
    checkSessionStatus: builder.mutation({
      async queryFn(data) {
        try {
          const callable = httpsCallable(functions, 'checkSessionStatus')
          const result = await callable(data)

          return { data: result.data }
        } catch (error) {
          const err = error as FirebaseError
          return {
            error: {
              status: err.code || 500,
              data: {
                message: err.message
              }
            },
          }
        }
      },
      invalidatesTags: [{ type: 'User' }]
    }),
  }),
})

export const {
  useTriggerMembershipPaymentMutation,
  useCheckSessionStatusMutation
} = stripeApiSlice